// @ts-check
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import ChoosePartners, {
  useChoosePartners,
} from '../../../../components/ChoosePartners/ChoosePartners';
import Footer, {
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageTitle
} from '../../../../components/Layout/PageHeader';
import useFormikOrchestration from '../../../../components/useFormikOrchestration';
import { useCommonLinks } from '../../_config';

/**
 * Renders the choose partner screen or the send message screen
 */
export default function SendNotificationPage({ match }) {
  const { workspaceId, importId } = match.params;
  const link = useCommonLinks();
  const { i18n } = useLingui();
  const props = useChoosePartners({ workspaceId, importId });
  const { triggerSubmit, setFormikContext, isValid } = useFormikOrchestration();
  const locale = i18n.locale;

  return (
    <Layout>
      <PageHeader>
        <PageTitle>
          <Trans>Choose partners</Trans>
        </PageTitle>
      </PageHeader>
      <Main>
        <ChoosePartners
          {...props}
          setFormikContext={setFormikContext}
          onSubmit={async (exhibitorIds) => {
            if (!exhibitorIds?.length) return;
            await props.createCampaignAndRedirect(exhibitorIds);
          }}
        />
      </Main>
      <Footer>
        <CancelButton to={link.root()}>
          <Trans>Cancel</Trans>
        </CancelButton>
        <NextButton
          onClick={triggerSubmit}
          disabled={!isValid || props.isCreatingCampaign}
        />
      </Footer>
    </Layout>
  );

}

